import { Controller } from "@hotwired/stimulus"

// Controller for date filter presets in direct sales listing
export default class extends Controller {
  static targets = ["fromDate", "toDate"]

  setPreset(event) {
    const fromDate = event.currentTarget.dataset.datePresetFromParam
    const toDate = event.currentTarget.dataset.datePresetToParam

    // Update the date fields
    if (this.hasFromDateTarget) {
      this.fromDateTarget.value = fromDate
    }
    if (this.hasToDateTarget) {
      this.toDateTarget.value = toDate
    }

    // Submit the form automatically
    const form = this.element.closest("form")
    if (form) {
      form.submit()
    }
  }

  clearDates() {
    // Clear the date fields
    if (this.hasFromDateTarget) {
      this.fromDateTarget.value = ""
    }
    if (this.hasToDateTarget) {
      this.toDateTarget.value = ""
    }

    // Submit the form automatically
    const form = this.element.closest("form")
    if (form) {
      form.submit()
    }
  }
}
